<script>
	import { Route, router } from "tinro";

	import Main from "./routes/Main.svelte";
	import Invite from "./routes/Invite.svelte";
	import Admin from "./routes/Admin.svelte";
	import Error from "./routes/Error.svelte"
	import Protected from "./routes/Protected.svelte"
	import Whitelist from "./routes/Whitelist.svelte";
    import Donate from "./routes/Donate.svelte";
	import Playerlist from "./routes/Playerlist.svelte";

	import Navigation from "./include/Navigation.svelte";
	import Footer from "./include/Footer.svelte";

	import { user_info } from "./util/stores";

	let fetch_user_info = async () => {
		let user_response = await fetch("/api/me").then((res) => res.json());
		if (user_response.status == 200)
			$user_info = user_response.data
	}

	$: authenticated = $user_info.auth != undefined;
	$: registered = $user_info.data != undefined;
	$: donor = registered && $user_info.data.donor;
	$: admin = registered && $user_info.data.admin;

	// Fetch userinfo whenever route is changed
	$: $router.path, fetch_user_info();
</script>

<Navigation />

<div class="wrapper">
	<main>
		<!-- Authenticated routes -->
		<Route path="/whitelist">
			{#if authenticated}
			<Whitelist on:update_user_info={fetch_user_info} />
			{:else}
			<div class="container">
				You need to be logged in to access this page
				<a href="/login" tinro-ignore><button class="btn blue">Log in with discord</button></a>
			</div>
			{/if}
		</Route>

		<!-- Register protected routes -->
		<Route path="/playerlist">
			{#if registered}
			<Playerlist />
			{:else}
			<Protected />
			{/if}
		</Route>
		
		<!-- Donor protected routes -->
		<Route path="/invite">
			{#if donor}
			<Invite />
			{:else}
			<Protected />
			{/if}
		</Route>
		
		<!-- Admin protected routes -->
		<Route path="/admin">
			{#if admin}
			<Admin />
			{:else}
			<Protected />
			{/if}
		</Route>


		<Route path="/"><Main /></Route>
		<Route path="/donate"><Donate on:update_user_info={fetch_user_info} /></Route>
		<Route fallback><Error /></Route>
	</main>
	<Footer />
</div>